import { z } from 'zod/v4';

import { normalizeImageWidgetArgs } from './image-widget-args.normalization';
import { partialImageWidgetDataSchema } from './partial-image-widget-data.schema';

/**
 * `data` is the same shared partial `create_image_widget` uses (minus create's required-`url`
 * tightening), kept deliberately identical so a model that has just seen its own create call in the
 * conversation history can pattern-match straight onto this tool — the same reasoning behind
 * `update_button_widget` reusing `partialButtonItemSchema`.
 */
const updateImageWidgetObjectSchema = z.object({
    widgetId: z.string().describe('Id of the image widget to update.'),
    data: partialImageWidgetDataSchema.describe(
        'Partial patch — only the fields you provide are changed, everything else on the widget is left as-is.'
    ),
});

export const updateImageWidgetArgsSchema = z.preprocess(normalizeImageWidgetArgs, updateImageWidgetObjectSchema);
